import React, { useState } from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'

import { useEventFeedsContext } from '../../context'
import './styles.scss'
import { useEffect } from 'react'
import { useRef } from 'react'

const FeedNameEditor = () => {
  const { dispatch, ACTIONS, data } = useEventFeedsContext()
  const [isEditing, setIsEditing] = useState(false)
  const [name, setName] = useState('')
  const inputRef = useRef(null)

  const handleStartEditing = () => {
    setIsEditing(true)
    inputRef.current.focus()
  }

  const handleCancelEditing = () => {
    handleStopEditing()
  }

  const handleStopEditing = () => {
    setIsEditing(false)
  }

  const handleInputChange = (event) => {
    setName(event.target.value)
  }

  const handleSaveName = () => {
    dispatch({ type: ACTIONS.UPDATE_NAME, payload: name })
    handleStopEditing()
  }

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSaveName()
    }

    if (event.key === 'Escape') {
      handleCancelEditing()
      setName(data.name)
    }
  }

  useEffect(() => {
    setName(data.name)
  }, [data.name])

  return (
    <div className="feed-name-editor__container">
      <If condition={!isEditing}>
        <>
          <h2 className="feed-name-editor__title">{data.name}</h2>
          <IconButton
            className="feed-name-editor__edit-icon"
            iconProps={{ icon: 'edit', width: 24, height: 24, color: 'currentColor' }}
            onClick={handleStartEditing}
          />
        </>
      </If>
      <input
        ref={inputRef}
        style={isEditing ? { opacity: 1, width: `${name.length}ch` } : { width: 0, opacity: 0 }}
        className="feed-name-editor__input"
        value={name}
        onBlur={handleSaveName}
        onKeyDown={handleInputKeyDown}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default FeedNameEditor
